import PageWrapper from "../page-wrapper/page-wrapper.components";
import { Video } from "lucide-react";

const VideoCard = ({ href, imageSrc, title }) => (
    <a
        href={href}
        className="block group"
    >
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all">
            <div className="aspect-[4/3] overflow-hidden bg-gray-100 relative">
                <img
                    src={imageSrc}
                    alt={title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 flex items-center justify-center bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity">
                    <div className="w-12 h-12 bg-white/90 rounded-full flex items-center justify-center">
                        <div className="w-0 h-0 border-t-6 border-t-transparent border-b-6 border-b-transparent border-l-8 border-l-primary ml-1"></div>
                    </div>
                </div>
            </div>
            <div className="p-3">
                <p className="text-sm font-medium text-gray-700 group-hover:text-primary transition-colors line-clamp-2">
                    {title}
                </p>
            </div>
        </div>
    </a>
);

const VideosPage = () => {
    const videos = [
        { href: "/user/video/claimsnaphowto/Welcome to ClaimSnap (How to Claim)", imageSrc: "/thumbnails/ClaimSnapHowTo.png", title: "Welcome to ClaimSnap (How to Claim)" },
        { href: "/user/video/choosenhc/Why Choose National HealthClaim", imageSrc: "/thumbnails/WhyChooseNHC.png", title: "Why Choose NHC" },
        { href: "/user/video/businessowners/Business Owners", imageSrc: "/thumbnails/BusinessOwnerTile.png", title: "For Business Owners" },
        { href: "/user/video/detachhsa/Detach HSA", imageSrc: "/thumbnails/DetachHSA.png", title: "Detach Your HSA" },
        { href: "/user/video/onlineenrollments/Online Enrollments", imageSrc: "/thumbnails/OnlineEnrollments.png", title: "Online Enrollment" },
        { href: "/user/video/flexdemo/Flex Allocation", imageSrc: "/thumbnails/FlexDemo.png", title: "Flexible Spending Account Demo" },
        { href: "/user/video/enhancedbenefits/HSA LSA Plus - Enhanced Benefits", imageSrc: "/thumbnails/EnhancedBenefits.png", title: "HSA/LSA Plus (Enhanced Benefits)" },
    ];

    return (
        <PageWrapper>
            <div className="flex-1 px-6 md:px-12 lg:pl-12 lg:pr-24 py-6 pb-5 overflow-y-auto">
                {/* page header with icon */}
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-primary/10 rounded-xl">
                        <Video className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
                            Videos
                        </h1>
                        <p className="text-sm text-gray-500">
                            Marketing videos and tutorials
                        </p>
                    </div>
                </div>

                {/* content */}
                <div className="bg-white rounded-2xl shadow-card p-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {videos.map((video, index) => (
                            <VideoCard key={index} {...video} />
                        ))}
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
};

export default VideosPage;
